import React, { useState, useEffect, useRef } from "react";
import { Button, Col, Modal, Row, Spinner, Container } from "react-bootstrap";
import OrderPayCashHook from "../../hook/checkout/OrderPayCashHook";
import ViewAddressHook from "../../hook/user/ViewAddressHook";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import AddAddressHook from "../../hook/user/AddAddressHook";
import { useTranslation } from "react-i18next";
import UserMapLocation from "../User/UserMapLocation";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

function removeHyperPayForm() {
  console.log('on return use effect ');
  //remove prev hyperpay form from div
  const form = document.getElementById('hyperPay');
  console.log('form', form);
  if (form?.hasChildNodes()) {
    var children = form.childNodes;
    for (var i = children.length - 1; i >= 0; i--) {
      var child = children[i];
      if (child.nodeType === 1) { // Check if it's an element node
        form.removeChild(child);
      }
    }
    //form.remove();
  }
}
//import baseURL from "../../Api/baseURL";

//const baseURLString = baseURL.defaults.baseURL;

const PaymentMethod = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const prevHyperPayCheckOutRes = useRef();
  const firstRenderRef = useRef(true);

  const [res] = ViewAddressHook();
  const [
    handleChooseAddress,
    createOrderCash,
    proceedWithCheckout,
    payments,
    totalPriceData,
    handlePaymentMethods,
    selectCard, setSelectCard,
    selectCardModal, setSelectCardModal,
    tabbyPhoneNumber, setTabbyPhoneNumber,
    loadingButton,
  ] = OrderPayCashHook(parseInt(location?.state?.shippingCost) || 0);

  // console.log('location?.state',location?.state);

  const settingsRes = useSelector((state) => state.settingsReducers.settings);

  const currencytype = Cookies.get("i18next") === "ar" ? settingsRes.data?.defaultCurrancy.ar : settingsRes.data?.defaultCurrancy.en

  // console.log('parseInt(location?.state?.shippingCost)');
  // console.log(parseInt(location?.state?.shippingCost));

  const [
    name,
    zone,
    city,
    address,
    mobile,
    closeSign,
    onChangeName,
    onChangeZone,
    onChangeCity,
    onChangeAddress,
    onChangeMobile,
    onChangeCloseSign,
    onSubmit,
    show,
    handleShow,
    handleClose,
    latitude,
    longitude,
    onChangeLatLang,
    showAddressDetails,



  ] = AddAddressHook(2);

  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [showTabbyPopUp, setShowTabbyPopUp] = useState(false);
  const [, setRenderTrick] = useState(false);


  //  const divElement = document.getElementById('hyperPay');
  //  console.log(divElement?.firstChild);
  //const hyperPayCheckOutRes=useSelector((state)=>state.HyperPayReducer.checkOut);
  const { isLoading: hyperPayLoading, checkOut: hyperPayCheckOutRes } = useSelector((state) => state.HyperPayReducer);

  // console.log('hyperPayCheckOutRes');
  // console.log(hyperPayCheckOutRes);

  useEffect(() => {
    removeHyperPayForm();
  }, []);


  useEffect(() => {
    // if (prevHyperPayCheckOutRes.current?.id) return;
    if (firstRenderRef.current == true) {
      firstRenderRef.current = false;
      return;
    }
    if (hyperPayCheckOutRes?.id) {

      prevHyperPayCheckOutRes.current = hyperPayCheckOutRes;
      const hyperpay = payments?.find(el => el.key = 8);
      const checkOutId = hyperPayCheckOutRes.id;

      // console.log('checkOutId');
      // console.log(checkOutId);
      // console.log('hyperpay.paymentKey');
      // console.log(hyperpay?.paymentKey);



      //////////create form with action ////////////
      let form = document.createElement('form');

      //https://shelly-ksa.com/user/allorders
      //https://shelly-az.com/
      //${baseURLString}/user/allorders
      form.setAttribute('action', `https://shelly-az.com/order/paymentStatus`);
      form.setAttribute('class', "paymentWidgets");
      form.setAttribute('data-brands', `${selectCard}`);
      document.getElementById("hyperPay").appendChild(form);
      // form.submit();
      const paymentUrl = hyperpay.paymentKey;

      //test
      // const paymentUrlWithCheckout = `https://eu-test.oppwa.com/v1/paymentWidgets.js?checkoutId=${checkOutId}`;

      //life
      const paymentUrlWithCheckout = `https://eu-prod.oppwa.com/v1/paymentWidgets.js?checkoutId=${checkOutId}`;

      console.log('paymentUrlWithCheckout');
      console.log(paymentUrlWithCheckout);
      //2-create script tag
      const script = document.createElement('script');

      // script.type='text/javascript';
      script.src = paymentUrlWithCheckout;
      console.log('script', script);
      // //3-append tag to body
      document.getElementById("hyperPay").appendChild(script);
      setLoadingSpinner(false);
      //  <form action="{shopperResultUrl}" class="paymentWidgets" data-brands="VISA MASTER AMEX"></form>
    }

    // return ()=>{
    //   console.log('on return use effect ');
    //   //remove prev hyperpay form from div
    //   removeHyperPayForm();
    // }
  }, [hyperPayCheckOutRes]);

  return (
    <div>
      <Modal show={show} onHide={handleClose}>

        <div className="border-0 shadow-sm font">
          <Modal.Header className="bg-light border-bottom-0 pb-0">
            <Modal.Title className="fw-bold fs-5 text-dark font">
              <i className="fa-solid fa-location-dot me-2 text-primary"></i>
              {t("add new address")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-4 pb-0">
            <Row>
              <Col xs={12}>
                <div className="mb-4">
                  <label htmlFor="address" className="form-label text-muted fw-bold small">{t("Title name")}</label>
                  <input
                    id="address"
                    value={name}
                    onChange={onChangeName}
                    type="text"
                    className="form-control bg-light border-0 py-2 font"
                    placeholder={t("Title name")}
                  />
                </div>

                {showAddressDetails && (
                  <>
                    <div className="mb-4">
                      <label htmlFor="closeSign" className="form-label text-muted fw-bold small">{t("nearest mark")}</label>
                      <input
                        id="closeSign"
                        value={closeSign}
                        onChange={onChangeCloseSign}
                        type="text"
                        className="form-control bg-light border-0 py-2 font"
                        placeholder={t("nearest mark")}
                      />
                    </div>
                    
                    <Row>
                      <Col md={6}>
                        <div className="mb-4">
                          <label htmlFor="phone" className="form-label text-muted fw-bold small">{t("phone number")}</label>
                          <input
                            id="phone"
                            value={mobile}
                            onChange={onChangeMobile}
                            type="text"
                            className="form-control bg-light border-0 py-2 text-start font"
                            dir="ltr"
                            placeholder={t("phone number")}
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-4">
                          <label htmlFor="zone" className="form-label text-muted fw-bold small">{t("region")}</label>
                          <input
                            id="zone"
                            value={zone}
                            onChange={onChangeZone}
                            type="text"
                            className="form-control bg-light border-0 py-2 font"
                            placeholder={t("region")}
                          />
                        </div>
                      </Col>
                    </Row>

                    <div className="mb-4">
                      <label htmlFor="city" className="form-label text-muted fw-bold small">{t("city")}</label>
                      <input
                        id="city"
                        value={city}
                        onChange={onChangeCity}
                        type="text"
                        className="form-control bg-light border-0 py-2 font"
                        placeholder={t("city")}
                      />
                    </div>
                  </>
                )}
                
                <div className="mb-4">
                  <label htmlFor="notes" className="form-label text-muted fw-bold small">{t("Notes")}</label>
                  <textarea
                    id="notes"
                    value={address}
                    onChange={onChangeAddress}
                    className="form-control bg-light border-0 py-2 font"
                    rows="3"
                    placeholder={t("Notes")}
                  />
                </div>

                <div className="rounded-3 overflow-hidden shadow-sm mb-4 border border-light">
                  <UserMapLocation latitude={latitude} longitude={longitude} onPress={onChangeLatLang} />
                </div>

              </Col>
            </Row>
            <ToastContainer />
          </Modal.Body>
          
          <Modal.Footer className="border-top-0 pt-0">
            <Button
              className="px-4 py-2 fw-bold font"
              variant="light"
              onClick={handleClose}
            >
              {t("retreat")}
            </Button>
            <Button 
              onClick={onSubmit} 
              className="px-5 py-2 fw-bold text-white border-0 font" 
              style={{ backgroundColor: settingsRes?.data?.cartColor || settingsRes?.data?.primaryColor || "#3182ce", borderRadius: '8px' }}
            >
              {t("add adress")}
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      <Modal show={selectCardModal} onHide={() => setSelectCardModal(false)} >
        <Modal.Body>
          <div>
            <input
              onChange={() => {
                setSelectCard('VISA');
              }}
              style={{ cursor: "pointer" }}
              name="group"
              id="group2"
              type="radio"
              value={'VISA'}
              className="mt-2"
            />
            <label
              className="mx-2"
              for="group2"
              style={{ cursor: "pointer" }}
            >
              VISA
            </label>
          </div>

          <div>

            <input
              onChange={() => setSelectCard('MASTER')}
              style={{ cursor: "pointer" }}
              name="group"
              id="group2"
              type="radio"
              value={'MASTER'}
              className="mt-2"
            />
            <label
              className="mx-2"
              for="group2"
              style={{ cursor: "pointer" }}
            >
              Master Card
            </label>
          </div>

          <div>
            <input
              onChange={() => setSelectCard('MADA')}
              style={{ cursor: "pointer" }}
              name="group"
              id="group3"
              type="radio"
              value={'MADA'}
              className="mt-2"
            />
            <label
              className="mx-2"
              for="group3"
              style={{ cursor: "pointer" }}
            >
              MADA
            </label>
          </div>

          <div>
            <input
              onChange={() => setSelectCard('APPLEPAY')}
              style={{ cursor: "pointer" }}
              name="group"
              id="group3"
              type="radio"
              value={'APPLEPAY'}
              className="mt-2"
            />
            <label
              className="mx-2"
              for="group3"
              style={{ cursor: "pointer" }}
            >
              APPLE PAY
            </label>
          </div>

          <div>
            <input
              onChange={() => setSelectCard('STC_PAY')}
              style={{ cursor: "pointer" }}
              name="group"
              id="group3"
              type="radio"
              value={'STC_PAY'}
              className="mt-2"
            />
            <label
              className="mx-2"
              for="group3"
              style={{ cursor: "pointer" }}
            >
              STC
            </label>
          </div>

          <div>
            <input
              onChange={() => {
                // setShowTabbyPopUp(true);
                setSelectCard('TABBY');
              }}
              style={{ cursor: "pointer" }}
              name="group"
              id="group3"
              type="radio"
              value={'TABBY'}
              className="mt-2"
            />
            <label
              className="mx-2"
              for="group3"
              style={{ cursor: "pointer" }}
            >
              Tabby
            </label>
          </div>

        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-start w-100">
            <button onClick={() => {
              if (selectCard == 'TABBY' && tabbyPhoneNumber == '') {
                setShowTabbyPopUp(true);

              }
              else {
                setLoadingSpinner(true);
                setSelectCardModal(false);

                createOrderCash();
              }


            }} className="btn-add-address" style={{ width: 'fit-content', padding: '10px', color: 'black',  backgroundColor: settingsRes?.data?.cartColor ? settingsRes?.data?.cartColor : settingsRes?.data?.primaryColor }}>
              اختيار
            </button>
          </div>

        </Modal.Footer>
      </Modal>

      {/* tabby pop up showTabbyPopUp */}
      {
        showTabbyPopUp && <>
          <Modal show={showTabbyPopUp} onHide={() => setShowTabbyPopUp(false)}>

            <div style={{ width: '100%' }}>
              <Modal.Header>
                {/* <Modal.Title>
                  <div className="admin-content-text font"> {t("add new address")} </div>
                </Modal.Title> */}
              </Modal.Header>
              <Modal.Body>
                <div >
                  <Row >
                    <Col sm="8" style={{ width: '100%' }}>
                      <label htmlFor="number_tabby" >{t("phone number")}</label>
                      <input
                        id='number_tabby'
                        value={tabbyPhoneNumber}
                        onChange={(e) => setTabbyPhoneNumber(e.target.value)}
                        type="text"
                        className="input-form d-block mt-2 px-3"
                        placeholder={t("phone number")}
                      />
                    </Col>
                  </Row>

                  <ToastContainer />
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div className="d-flex justify-content-between w-100">
                  <button
                  onClick={()=>{
                    setShowTabbyPopUp(false);
                    setSelectCardModal(false);
                    createOrderCash();
                  }}
                   className="btn-save d-inline mt-2 " style={{  backgroundColor: settingsRes?.data?.cartColor ? settingsRes?.data?.cartColor : settingsRes?.data?.primaryColor }}>
                    {t("Checkout")}
                  </button>

                  <Button
                    className="font d-inline mt-2"
                    variant="secondary"
                    onClick={() => setShowTabbyPopUp(false)}
                  >
                    {t("retreat")}
                  </Button>
                </div>
              </Modal.Footer>
            </div>
          </Modal>
        </>
      }


      {/* <form action="https://hyperpay.docs.oppwa.com/tutorials/integration-guide/registrationtokens" class="paymentWidgets" data-brands="VISA MASTER AMEX">
        <label>xxxxxxxxxxxxxx</label>

        <button type="submit">submit</button>
      </form> */}

      <div className="cart-page-bg">
        <Container>
          <Row className="g-4">
            
            {/* Main Content (Left Column) */}
            <Col xs="12" lg="8">
              
              {/* Address Section */}
              <div className="checkout-section-card">
                <div className="checkout-section-title">
                  <i className="fa-solid fa-location-dot"></i>
                  {payments.length !== 0 ? t("choose address") : t("choose address")}
                </div>
                
                <div className="d-flex flex-column flex-md-row gap-3">
                  <div className="flex-grow-1">
                    <select
                      name="address"
                      id="address"
                      className="checkout-address-select"
                      onChange={handleChooseAddress}
                    >
                      <option value="0">{t("choose address")}</option>
                      {res.length >= 1 && res.map((el) => (
                        <option key={el._id} value={el._id}>
                          {el.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  
                  <button 
                    onClick={handleShow} 
                    className="btn btn-primary fw-bold text-nowrap px-4 border-0"
                    style={{ backgroundColor: settingsRes?.data?.cartColor || settingsRes?.data?.primaryColor || "#3182ce" }}
                  >
                    <i className="fa-solid fa-plus me-2"></i>
                    {t("add new adress")}
                  </button>
                </div>
              </div>

              {/* Payment Methods Section */}
              <div className="checkout-section-card">
                <div className="checkout-section-title">
                  <i className="fa-solid fa-credit-card"></i>
                  {t("choose payment method")}
                </div>
                
                <div className="payment-method-grid">
                  {payments && payments.map((el, i) => {
                    const isSelected = document.getElementById(`payment-${el._id}`)?.checked;
                    return (
                      <label 
                        key={i} 
                        className={`payment-card ${isSelected ? 'selected' : ''}`}
                        onClick={(e) => {
                          const radio = document.getElementById(`payment-${el._id}`);
                          if(radio) {
                            radio.checked = true;
                            // Trigger the hook's change handler
                            handlePaymentMethods({ target: { value: el._id } });
                            // Force re-render for class change
                            setRenderTrick(prev => !prev);
                          }
                        }}
                      >
                        <input
                          id={`payment-${el._id}`}
                          name="payment_group"
                          type="radio"
                          value={el._id}
                          className="d-none"
                        />
                        <div className="payment-icon">
                          {/* Fallback icons based on name/type if needed. Assuming text for now or simple icons */}
                          <i className="fa-regular fa-credit-card"></i>
                        </div>
                        <span>{el.nameAr}</span>
                      </label>
                    );
                  })}
                </div>
                
                {/* HyperPay Injection Div */}
                {loadingSpinner && <div className="text-center mt-4"><Spinner animation="border" /></div>}
                <div id="hyperPay" className="mt-4" style={{ direction: 'ltr' }}></div>
              </div>

            </Col>
            
            {/* Order Summary (Right Column) */}
            <Col xs="12" lg="4">
              <div className="cart-summary-card position-sticky" style={{ top: "20px" }}>
                 <div className="cart-summary-title">{t("Order Summary")}</div>
                 
                 <div className="cart-summary-row mt-3">
                   <span>{t("Total")}</span>
                   <span className="fs-5 fw-bolder text-primary">
                     {Number(totalPriceData)?.toFixed(2)} {currencytype}
                   </span>
                 </div>
                 
                 <button
                   id="submit_button"
                   onClick={createOrderCash}
                   disabled={loadingButton}
                   className="cart-checkout-btn border-0 text-white mt-4 py-3 fs-5" 
                   style={{ backgroundColor: settingsRes?.data?.cartColor || settingsRes?.data?.primaryColor || "#3182ce" }}
                 >
                   {(hyperPayLoading || loadingButton) ? <Spinner size="sm" /> : (
                     <>
                       <i className="fa-solid fa-lock me-2"></i>
                       {t("Checkout")}
                     </>
                   )}
                 </button>
                 
                 <div className="text-center text-muted small mt-3">
                   <i className="fa-solid fa-shield-halved me-1"></i>
                   {t("Secure Payment")}
                 </div>
              </div>
            </Col>

          </Row>
        </Container>
      </div>
      <ToastContainer />
    </div>
  );
};

export default PaymentMethod;


